import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/nedGlobe/web';
import accessDenied from '../views/AccessDenied.vue';
import ErrorMessage from '../views/ErrorMessage.vue';
import Base from '../views/web/Base.vue';
import PrintExecuter from '../components/printing/PrintExecuter.vue';
import Accessible from '../views/web/Accessible.vue';
import AccessibleInfo from '../components/geo/panels/accessible/Info';
import AccessibleSearch from '../components/geo/panels/accessible/Search';
import AccessibleOptions from '../components/geo/panels/accessible/Options';
import AccessibleData from '../components/geo/panels/accessible/Data';
import Conditions from '../views/Conditions.vue';
import SecuredUrl from '../views/SecuredUrl.vue';

Vue.use(Router);

const parsingErrorMessage = (route) => ({ message: route.params.message });
const parsingIdAndNameAndUrl = (route) => ({ id: Number(route.params.id), name: route.params.name, url: route.params.url });
const accessDeniedPath = '/accessDenied';
const conditionsPath = '/conditions';

const router = new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        // Web

        {
            path: '/web/:tma/toegankelijk',
            component: Accessible,
            meta: { requiresAuthentication: false },
            redirect: 'accessibleInfo',
            props: true,
            children: [
                {
                    path: 'kaart',
                    name: 'accessibleInfo',
                    component: AccessibleInfo,
                    meta: { showMap: true }
                },
                {
                    path: 'data',
                    name: 'accessibleData',
                    component: AccessibleData,
                    meta: { showMap: false }
                },
                {
                    path: 'search',
                    name: 'accessibleSearch',
                    component: AccessibleSearch,
                    meta: { showMap: false }
                },
                {
                    path: 'options',
                    name: 'accessibleOptions',
                    component: AccessibleOptions,
                    meta: { showMap: false }
                }
            ]
        },
        {
            path: '/web',
            name: 'WebMap',
            component: Base,
            props: true,
            meta: {
                requiresAuthentication: false,
                title: 'NedGlobe'
            },
            pathToRegexpOptions: { strict: true, },
            children: [
                {
                    path: '/',
                    name: 'ngMap',
                },
                {
                    path: 'print',
                    name: 'ngPrint',
                    component: PrintExecuter
                }
            ]
        },
        {
            path: '/web*',
            redirect: '/web'
        },
        // ErrorMessage
        {
            path: '/error/:message?',
            name: 'errorMessage',
            component: ErrorMessage,
            props: parsingErrorMessage,
        },
        //Logout route
        {
            path: '/logout',
            name: 'logout'
        },
        // Dashboard access denied
        {
            path: accessDeniedPath,
            name: 'accessDenied',
            component: accessDenied
        },
        // Conditions
        {
            path: conditionsPath,
            name: 'conditions',
            component: Conditions
        },
        // SecuredUrl
        {
            path: '/securedUrl/:id/:name/:url',
            name: 'securedUrl',
            props: parsingIdAndNameAndUrl,
            component: SecuredUrl
        },
        // Other paths
        {
            path: '*',
            name: 'accessDeniedCatchAll',
            redirect: to => {
                const nonDashboardApps = ['/mobile', '/web', '/portal', '/error'];
                const { path } = to;
                // Probable mistakes in mobile/web/portal URL's
                if (nonDashboardApps.some(a => path.startsWith(a))) {
                    return '/error/access_denied';
                } else {
                    // This shows the Dashboard access Denied page including navbar
                    return accessDeniedPath;
                }
            }
        },
    ]
});

/**
 * Set isIE flag
 * @return {Boolean} [description]
 */
router.isIE = function () {
    if (store.getters.isIe === null) {
        const uagent = navigator.userAgent.toLowerCase();
        const isIe = /msie/.test(uagent) || /trident/.test(uagent);
        // set store value
        store.dispatch('setIsIeState', isIe);
    }
    return store.getters.isIe;
};

/**
* Global route guard
* @param  {string} to the target route
* @param  {string} from the current route
* @param  {string} next to resolve the hook
*/
store.commit('SET_CONTEXT', 'web');
store.commit('SET_REQUIRES_AUTHENTICATION', false);

export default router;
